export const ACTION_GET_SETTING = '/Account/GetSettings';